{
  "toast": {
    "aBTestStarted": "A/B test started",
    "draftCampaignCreated": "Draft campaign créé",
    "campaignScheduled": "Campagne scheduled",
    "journeyCreated": "Journey créé",
    "journeyFlowSaved": "Journey flow enregistré",
    "segmentSaved": "Segment enregistré",
    "templateSaved": "Template enregistré",
    "templateCompiled": "Modèle compilé",
    "calendarEntryCreated": "Entrée de calendrier créée",
    "reportExported": "{{reportType}} exporté",
    "draftCreated": "Brouillon créé : {{name}}",
    "abWinner": "Gagnant : variante {{variant}}",
    "recipientSuppressed": "Destinataire supprimé",
    "suppressionReleased": "Suppression levée",
    "assetSaved": "Ressource enregistrée"
  },
  "errors": {
    "failedToLoadABTests": "Échec du chargement de a/B tests",
    "failedToCreateABTest": "Échec de la création de a/B test",
    "failedToPickWinner": "Échec : pick winner",
    "enterACampaignName": "Saisissez a campaign name",
    "selectAnAudienceSegment": "Sélectionnez un audience segment",
    "failedToLoadCampaigns": "Échec du chargement de campaigns",
    "failedToLoadSegments": "Échec du chargement de segments",
    "failedToLoadTemplates": "Échec du chargement de templates",
    "failedToCreateCampaign": "Échec de la création de campaign",
    "actionFailed": "Échec de action",
    "failedToLoadPerformance": "Échec du chargement de performance",
    "attributionFailed": "Échec de attribution",
    "failedToLoadJourneys": "Échec du chargement de journeys",
    "failedToCreateJourney": "Échec de la création de journey",
    "failedToSaveJourneyFlow": "Échec de l'enregistrement de journey flow",
    "failedToLoadLifecyclePresets": "Échec du chargement de lifecycle presets",
    "exportFailed": "Échec de l'export",
    "failedToCreateSegment": "Échec de la création de segment",
    "previewFailed": "Échec de preview",
    "templateNameIsRequired": "Template name is requis",
    "failedToCreateTemplate": "Échec de la création de template",
    "failedToCreateCalendarEntry": "Échec de la création de l'entrée de calendrier",
    "failedToGenerateAiContent": "Échec de la génération du contenu IA",
    "failedToSuppressRecipient": "Échec de la suppression du destinataire",
    "failedToReleaseSuppression": "Échec de la levée de la suppression",
    "failedToSaveAsset": "Échec de l'enregistrement de la ressource"
  },
  "pages": {
    "noCampaignSelected": "No campaign sélectionnered",
    "selectACampaignFromTheList": "Sélectionnez une campagne dans la liste pour afficher les indicateurs de livraison et d'engagement.",
    "noAttributionData": "No attribution data",
    "scheduleCampaign": "Planification campagne",
    "campaigns": "Campagnes",
    "noCampaignsYet": "No campagnes yet",
    "createApproveScheduleAndLaunchMulti": "Create, approve, schedule, et launch multi-channel campaigns avec tracked delivery.",
    "createADraftWithAnAudience": "Create a draft avec an audience segment et template, then submit pour approbation.",
    "marketing": "Marketing",
    "engagement": "Engagement",
    "openRate": "Taux d'ouverture",
    "conversions": "Conversions",
    "engagementFunnel": "Engagement funnel",
    "campaignPerformanceEngagementAndConversionsFor": "Campaign performance, engagement, et conversions pour votre marketing scope",
    "espWebhooks": "ESP webhooks",
    "sendgridMailgunAndSimilarProvidersPost": "SendGrid, Mailgun, et similar providers POST open/click events à update campaign metrics",
    "journeys": "Parcours",
    "noJourneys": "No journeys",
    "automateNurtureFlowsWithTriggersActions": "Automate nurture flows avec triggers, actions, delays, et goals using a visual step builder.",
    "createAJourneyToAutomateFollow": "Create a journey à automate follow-ups after key events.",
    "lifecycle": "Cycle de vie",
    "oneClickDraftsForWelcomeCart": "One-click drafts pour welcome, cart recovery, win-back, upsell, et renewal programs.",
    "reports": "Rapports",
    "exportCampaignAndJourneyDataAnd": "Export campaign et journey data, et inspect multi-touch attribution per campaign.",
    "audienceSegments": "Audience segments",
    "noSegmentsYet": "Aucun segments pour le moment",
    "dynamicSegmentsWithRuleBuilderAnd": "Dynamic segments avec rule builder et live preview",
    "createYourFirstDynamicAudienceSegment": "Create votre first dynamic audience segment.",
    "templates": "Modèles",
    "noTemplates": "No templates",
    "reusableEmailContentWithVersioningVia": "Reusable email content avec versioning via le shared template service.",
    "createATemplateToAttachTo": "Create a template à attach à email campaigns.",
    "marketingCopilot": "Copilote marketing",
    "generateCampaignCopySubjectLines": "Générez des textes de campagne, objets, recommandations de canal et conseils de meilleure action suivante.",
    "copilot": "Copilote",
    "result": "Résultat",
    "consentAndSuppression": "Consentement et suppression",
    "reviewRecipientsBlockedByOptOuts": "Consultez les destinataires bloqués par désabonnements, rebonds, plaintes ou suppression manuelle.",
    "suppressionList": "Liste de suppression",
    "loadingSuppressions": "Chargement des suppressions...",
    "noSuppressedRecipients": "Aucun destinataire supprimé.",
    "contentAndMediaLibrary": "Contenu et médiathèque",
    "manageReusableMarketingAssets": "Gérez les ressources marketing réutilisables pour les campagnes, pages de destination et modèles.",
    "mediaLibrary": "Médiathèque",
    "formsAndLandingPages": "Formulaires et pages de destination",
    "marketingReusesLeadGenBuilders": "Marketing réutilise les outils d'acquisition Lead Gen existants afin de centraliser la capture, le consentement, le scoring et le routage.",
    "forms": "Formulaires",
    "createEmbeddedLeadRegistrationSurvey": "Créez des formulaires intégrés de prospect, d'inscription, de sondage et de feedback dans Lead Gen.",
    "landingPages": "Pages de destination",
    "buildCampaignLandingPages": "Créez des pages de destination de campagne avec SEO, suivi des conversions et variantes A/B dans Lead Gen.",
    "visitorTracking": "Suivi des visiteurs",
    "reviewFirstPartyWebsiteTracking": "Consultez le suivi web first-party, l'attribution et la conversion visiteur-prospect."
  },
  "calendar": {
    "title": "Calendrier marketing",
    "description": "Planifiez lancements, newsletters, vagues de nurture et activités de canal dans un calendrier de campagne partagé.",
    "breadcrumb": "Calendrier",
    "labels": {
      "activityTitle": "Titre de l'activité"
    },
    "actions": {
      "add": "Ajouter"
    },
    "sections": {
      "upcomingMarketingActivities": "Activités marketing à venir"
    },
    "defaults": {
      "marketingActivity": "Activité marketing"
    },
    "loading": "Chargement du calendrier...",
    "empty": "Aucune entrée de calendrier sur cette période.",
    "campaignLabel": "Campagne n° {{id}}"
  },
  "channels": {
    "title": "Campagnes SMS et WhatsApp",
    "description": "Gérez les campagnes marketing hors e-mail diffusées via les services de messagerie Social partagés.",
    "breadcrumb": "Canaux",
    "createCampaign": "Créer une campagne",
    "searchCampaigns": "Rechercher des campagnes",
    "channelCampaigns": "Campagnes {{channel}}",
    "loadingCampaigns": "Chargement des campagnes...",
    "noCampaignsFound": "Aucune campagne {{channel}} trouvée. Créez-en une depuis l'espace principal des campagnes.",
    "budgetCost": "Budget {{budget}} · Coût {{cost}}",
    "open": "Ouvrir"
  },
  "templates": {
    "sections": {
      "newEmailTemplate": "Nouveau modèle d'e-mail",
      "visualBlocks": "Blocs visuels",
      "library": "Bibliothèque"
    },
    "actions": {
      "addBlock": "Ajouter un bloc",
      "saveTemplate": "Enregistrer le modèle",
      "compileHtml": "Compiler le HTML"
    },
    "blockTypes": {
      "heading": "Titre",
      "text": "Texte",
      "button": "Bouton",
      "image": "Image"
    },
    "placeholders": {
      "imageUrl": "URL de l'image",
      "content": "Contenu",
      "buttonUrl": "URL du bouton"
    },
    "defaultBlocks": {
      "heading": "Bienvenue dans notre dernière actualité",
      "text": "Ajoutez votre message marketing ici.",
      "button": "En savoir plus",
      "newContentBlock": "Nouveau bloc de contenu"
    },
    "status": {
      "published": "publié"
    },
    "versionLabel": "v{{version}}",
    "loading": "Chargement..."
  },
  "labels": {
    "variantARef": "Variant A ref",
    "variantBRef": "Variant B ref",
    "sent": "Sent",
    "opens": "Opens",
    "clicks": "Clics",
    "bounces": "Bounces",
    "unsubscribes": "Unsubscribes",
    "conversions": "Conversions",
    "openRate": "Taux d'ouverture",
    "clickRate": "Click rate",
    "roi": "ROI",
    "moveUp": "Move up",
    "moveDown": "Move down",
    "removeStep": "Remove step",
    "stepType": "Step type",
    "action": "Opération",
    "waitAmount": "Wait amount",
    "unit": "Unité",
    "displayLabel": "Display label",
    "sendAt": "Send at",
    "matchMode": "Match mode",
    "field": "Champ",
    "operator": "Operator",
    "value": "Valeur",
    "name": "Nom",
    "channel": "Canal",
    "audience": "Audience",
    "template": "Template",
    "springPromo": "Spring promo",
    "selectSegment": "Select segment",
    "optional": "Facultatif",
    "trigger": "Trigger",
    "welcomeSeries": "Welcome series",
    "audienceOptional": "Audience (facultatif)",
    "useDefaultRules": "Use default règles",
    "campaign": "Campagne",
    "model": "Model",
    "selectCampaign": "Select campagne",
    "allModels": "All models",
    "segmentName": "Segment name",
    "templateName": "Template name",
    "subjectLine": "Subject line",
    "bodyHtmlOrPlainText": "Body (HTML ou plain text)",
    "task": "Tâche",
    "goal": "Objectif",
    "tone": "Ton",
    "source": "Origine",
    "recipient": "Destinataire",
    "assetName": "Nom de la ressource",
    "type": "Catégorie",
    "fileUrl": "URL du fichier",
    "date": "Date"
  },
  "options": {
    "task": {
      "campaignCopy": "Texte de campagne",
      "subjectLine": "Objet",
      "smsCopy": "Texte SMS",
      "whatsAppCopy": "Texte WhatsApp",
      "channelRecommendation": "Recommandation de canal",
      "nextBestAction": "Meilleure action suivante"
    },
    "channel": {
      "email": "E-mail",
      "sms": "SMS",
      "whatsApp": "WhatsApp",
      "multiChannel": "Multicanal"
    },
    "segmentField": {
      "leadScore": "Score du prospect",
      "purchaseHistory": "Historique d'achat (POS)",
      "expectedRevenue": "Revenu attendu",
      "location": "Localisation",
      "emailActivity": "Activité e-mail",
      "campaignActivity": "Activité de campagne",
      "websiteActivity": "Activité du site web"
    },
    "operator": {
      "contains": "contient"
    },
    "matchMode": {
      "anyRule": "Une règle (OR)",
      "allRules": "Toutes les règles (AND)"
    },
    "assetType": {
      "image": "Image",
      "video": "Vidéo",
      "document": "Document"
    }
  },
  "placeholders": {
    "newLeads": "nouveaux prospects",
    "bookAProductDemo": "réserver une démonstration produit",
    "professional": "professionnel",
    "generatedContentWillAppearHere": "Le contenu généré s'affichera ici.",
    "recipientAddressOrPhone": "email@example.com ou +15551234567"
  },
  "formActions": {
    "createDraft": "Créer un brouillon",
    "generate": "Générer",
    "remove": "Supprimer",
    "addRuleGroup": "+ Ajouter un groupe de règles",
    "suppress": "Supprimer",
    "release": "Libérer",
    "save": "Enregistrer"
  },
  "listActions": {
    "newCampaign": "Nouvelle campagne",
    "openBuilder": "Ouvrir l'outil"
  },
  "empty": {
    "noMarketingAssetsYet": "Aucune ressource marketing pour le moment."
  },
  "loading": {
    "assets": "Chargement des ressources..."
  }
}
